<template>
    <div>
        <div class="main-content">
            <h2>我的标签</h2>
            <div class="b-b m-b-md"></div>
            <div class="tips" v-if="tags.length === 0">
                您暂未获得标签数据，请前往
                <router-link to="/evaluate">测评中心</router-link>进行素质测评，生成个人标签。
            </div>
            <div class="row" v-if="tags.length !== 0">
                <div class="col-xs-12">
                    <div class="row">
                        <div class="col-xs-6 col-md-2 col-sm-3 m-t-b-sm" v-for="tag in tags" :key="tag">
                            <div class="indicator">
                                <div class="score">{{tag.score}}</div>
                                <div class="rate">
                                    领先于
                                    <span class="percent">{{tag.rate * 100}}%</span>的用户
                                </div>
                                <div class="title">{{tag.tag.name}}</div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <div class="main-content m-t-md" v-if="tags.length >= 3">
            <h2>标签雷达</h2>
            <div class="b-b m-b-md"></div>
            <div class="row">
                <div class="col-xs-12" id="radar-area">
    
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import { mapGetters } from 'vuex'
import Echarts from 'echarts/lib/echarts.js'
import 'echarts/lib/chart/radar.js'
import 'echarts/lib/component/legend'

import User from '../../resource/user'
export default {
    data: function () {
        return {
            tags: [],
            echarts: null,
            is_mounted: false
        }
    },
    computed: {
        ...mapGetters({
            'user': 'loginUser'
        })
    },
    created: function () {
        let that = this
        document.title = `我的标签-个人中心|${that.global.name}`
        if (that.user.category === 2) {
            that.$router.replace('/company')
        } else {
            that.load()
        }
    },
    watch: {
        tags: function (now) {
            let that = this
            if (that.is_mounted && now.length >= 3) {
                that.buildRadar()
            }
        }
    },
    mounted: function () {
        let that = this
        that.is_mounted = true
        if (that.tags.length >= 3) {
            that.buildRadar()
        }
    },
    methods: {
        load: function () {
            let that = this
            User.tags({}, {}).then(res => {
                let data = res.body
                if (data.code == 0) {
                    that.tags = data.result
                } else {
                    alert(data.msg)
                }
            }, res => { })
        },
        buildRadar: function () {
            let that = this
            if (!that.echarts) {
                that.echarts = Echarts.init(document.querySelector('#radar-area'))
            }
            let options = {
                legend: {
                    data: ['标签阈值', '我的标签'],
                    orient: 'vertical',
                    right: '20px'
                },
                radar: {
                    indicator: []
                },
                series: [{
                    name: '用户标签',
                    type: 'radar',
                    data: [
                        {
                            value: [],
                            name: '标签阈值'
                        },
                        {
                            value: [],
                            name: '我的标签'
                        }
                    ]
                }]
            };
            that.tags.forEach(function (tag) {
                options.radar.indicator.push({
                    'name': tag.tag.name,
                    'max': tag.tag.point_system
                })
                options.series[0].data[0].value.push(tag.tag.threshold_value)
                options.series[0].data[1].value.push(tag.score)
            }, this);
            that.echarts.setOption(options);
        }
    },
    destroyed: function () {
        let that = this
        if (that.echarts) {
            that.echarts.dispose()
            that.echarts = null
        }
    }
}
</script>
<style lang="less" scoped>
#radar-area {
    height: 300px;
}
</style>



// WEBPACK FOOTER //
// tag.vue?481db5cc